package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class StaffReportViewBy {
    @SerialName("SCHOOL")
    SCHOOL,
    @SerialName("CLASS")
    CLASS,
    @SerialName("STUDENT")
    STUDENT
}

@Serializable
enum class ReportPercentageOperator {
    @SerialName("<")
    LESS_THAN,
    @SerialName(">")
    GREATER_THAN,
    @SerialName("=")
    EQUAL_TO,
    @SerialName("BETWEEN")
    BETWEEN
}

@Serializable
enum class AttendanceReportCriteriaType {
    @SerialName("ATTENDANCE_PERCENTAGE")
    ATTENDANCE_PERCENTAGE,
    @SerialName("ATTENDANCE_STATUS")
    ATTENDANCE_STATUS
}

@Serializable
enum class AttendanceReportStatus {
    @SerialName("PRESENT")
    PRESENT,
    @SerialName("ABSENT")
    ABSENT,
    @SerialName("A-M")
    ABSENT_MORNING,
    @SerialName("A-A")
    ABSENT_AFTERNOON
}

@Serializable
enum class AcademicReportCriteriaType {
    @SerialName("OVERALL_SUMMARY")
    OVERALL_SUMMARY,
    @SerialName("EXAM_PERCENTAGE")
    EXAM_PERCENTAGE
}

@Serializable
enum class CombinedReportCriteriaType {
    @SerialName("ATTENDANCE_SUMMARY")
    ATTENDANCE_SUMMARY,
    @SerialName("EXAM_PERFORMANCE")
    EXAM_PERFORMANCE
}

@Serializable
enum class CombinedReportMatchType {
    @SerialName("ALL")
    ALL,
    @SerialName("ANY")
    ANY
}

@Serializable
data class AttendanceReportRequest(
    @SerialName("view_by") val viewBy: StaffReportViewBy,
    @SerialName("class_ids") val classIds: List<String>,
    @SerialName("from_date") val fromDate: String,
    @SerialName("to_date") val toDate: String,
    @SerialName("criteria_type") val criteriaType: AttendanceReportCriteriaType? = null,
    @SerialName("percentage_operator") val percentageOperator: ReportPercentageOperator? = null,
    @SerialName("percentage_values") val percentageValues: List<Double>? = null,
    @SerialName("status_value") val statusValue: AttendanceReportStatus? = null,
    val limit: Int = 5,
    val offset: Int = 0
)

@Serializable
data class AcademicPerformanceReportRequest(
    @SerialName("view_by") val viewBy: StaffReportViewBy,
    @SerialName("class_ids") val classIds: List<String>,
    @SerialName("exam_ids") val examIds: List<String>? = null,
    @SerialName("from_date") val fromDate: String,
    @SerialName("to_date") val toDate: String,
    @SerialName("criteria_type") val criteriaType: AcademicReportCriteriaType? = null,
    @SerialName("percentage_operator") val percentageOperator: ReportPercentageOperator? = null,
    @SerialName("percentage_values") val percentageValues: List<Double>? = null,
    @SerialName("category_filter") val categoryFilter: String? = null,
    val limit: Int = 5,
    val offset: Int = 0
)

@Serializable
data class CombinedPerformanceCriteriaRequest(
    @SerialName("criteria_type") val criteriaType: CombinedReportCriteriaType,
    @SerialName("percentage_operator") val percentageOperator: ReportPercentageOperator? = null,
    @SerialName("percentage_values") val percentageValues: List<Double>? = null,
    @SerialName("category_filter") val categoryFilter: String? = null
)

@Serializable
data class CombinedPerformanceReportRequest(
    @SerialName("view_by") val viewBy: StaffReportViewBy,
    @SerialName("class_ids") val classIds: List<String>,
    @SerialName("student_id") val studentId: String? = null,
    @SerialName("from_date") val fromDate: String,
    @SerialName("to_date") val toDate: String,
    val criteria: List<CombinedPerformanceCriteriaRequest>? = null,
    @SerialName("match_type") val matchType: CombinedReportMatchType = CombinedReportMatchType.ALL,
    val limit: Int = 5,
    val offset: Int = 0
)
